import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { animateScroll as scroll } from "react-scroll";
import { DateTime } from "luxon";

import Localization from "../../localization";
import Button from "../button";
import IconArrow from "../icons/arrow";
import IconPorto from "../icons/porto";
import IconEffect1 from "../icons/effect1";

import { appLocales } from "../../localization";
import { getUrl } from "../../utils/helper";
import { changeNewsletter } from "../../redux/actions/options";

class Footer extends Component {
    constructor(props) {
        super(props);

        this._onNewsletterPress = this._onNewsletterPress.bind(this);
        this._onScrollPress = this._onScrollPress.bind(this);
    }

    _renderTop(color) {
        return (
            <div className="flex flex-col items-center">
                <IconArrow
                    onClick={this._onScrollPress}
                    className={"w-32 cursor-pointer h-32 text-" + color}
                />
                <IconEffect1
                    className={
                        "mt-40 xl:mt-80 mb-60 xl:mb-80 w-80 xl:w-103 h-65 xl:h-84 text-" +
                        color
                    }
                />
            </div>
        );
    }

    _onNewsletterPress() {
        this.props.changeNewsletter(true);
    }

    _onScrollPress() {
        scroll.scrollToTop();
    }

    _renderBottom(color) {
        const { locale } = this.props;

        return (
            <div className="flex flex-col xl:flex-row items-center xl:items-end mt-60">
                <div className="hidden xl:block w-4/12">
                    <IconPorto className="w-155 h-44 text-blue" />
                </div>
                <div className="flex flex-col xl:flex-row items-center flex-1">
                    <p
                        className={
                            "font-judge font-bold text-20 xl:text-14 xl:mr-60 text-" +
                            color
                        }
                    >
                        {Localization[locale].footer.links.toUpperCase()}
                    </p>
                    <a
                        href={"https://www.instagram.com/campuspcs/"}
                        target={"_blank"}
                        className={
                            "text-20 xl:text-14 underline mt-16 xl:mt-0 xl:mr-60 text-" +
                            color
                        }
                        title={Localization[locale].footer.instagram}
                    >
                        {Localization[locale].footer.instagram}
                    </a>
                    <a
                        onClick={this._onNewsletterPress}
                        className={
                            "text-20 xl:text-14 cursor-pointer mt-16 xl:mt-0 underline text-" +
                            color
                        }
                        title={Localization[locale].footer.newsletter}
                    >
                        {Localization[locale].footer.newsletter}
                    </a>
                </div>
                <div className="block xl:hidden mb-40 mt-60">
                    <IconPorto className="w-155 h-44 text-blue" />
                </div>
                <div>
                    <p className={"text-14 font-judge font-bold text-" + color}>
                        CAMPUS PCS &copy; {DateTime.local().year}
                    </p>
                </div>
            </div>
        );
    }

    _renderContacts(color) {
        const { locale } = this.props;

        return (
            <div className="w-full px-40 xl:px-0 xl:w-8/12">
                <p
                    className={
                        "font-judge font-bold text-center xl:text-left text-30 mb-40 xl:mb-80 text-" +
                        color
                    }
                >
                    {Localization[locale].footer.informations.toUpperCase()}
                </p>
                <p
                    className={
                        "text-20 xl:text-23 text-center xl:text-left font-bold text-" +
                        color
                    }
                >
                    CAMPUS Paulo Cunha e Silva
                </p>
                <div className="flex mt-12 xl:mt-0 justify-center xl:justify-start items-center">
                    <p
                        className={
                            "hidden xl:block text-20 xl:text-23 mr-6 font-bold text-" +
                            color
                        }
                    >
                        {Localization[locale].footer.address}
                    </p>
                    <a
                        href="https://goo.gl/maps/a8MK4iCYHdPECFr99"
                        className={
                            "text-20 xl:text-23 text-center xl:text-left text-" +
                            color
                        }
                        title={"Travessa dos Campos 144, 4000-153 Porto"}
                    >
                        Travessa dos Campos 144, 4000-153 Porto
                    </a>
                </div>
                <div className="flex mt-16 xl:mt-0 justify-center xl:justify-start items-center">
                    <p
                        className={
                            "hidden xl:block text-20 xl:text-23 mr-6 font-bold text-" +
                            color
                        }
                    >
                        {Localization[locale].footer.phone}
                    </p>
                    <a
                        href="tel:+351223392216"
                        className={"text-20 xl:text-23 text-" + color}
                        title={"+ 351 223 392 216"}
                    >
                        + 351 223 392 216
                    </a>
                </div>
                <div className="flex mt-16 xl:mt-0 justify-center xl:justify-start items-center">
                    <p
                        className={
                            "hidden xl:block text-20 xl:text-23 mr-6 font-bold text-" +
                            color
                        }
                    >
                        {Localization[locale].footer.emails}
                    </p>
                    <a
                        href="mailto:campuspcs@agoraporto.pt"
                        className={"text-20 xl:text-23 text-" + color}
                        title={"campuspcs@agoraporto.pt"}
                    >
                        campuspcs@agoraporto.pt
                    </a>
                </div>
            </div>
        );
    }

    _onLocalePress(otherLocale) {
        let url = window.location.href.replace(
            "/" + this.props.locale,
            "/" + otherLocale
        );

        window.location.replace(url);
    }

    _renderLegalButtons(locale, backgroundColor, borderColor, textStyle) {
        return (
            <div className="w-full xl:w-310">
                <Button
                    text={Localization[locale].footer.subscribe_newsletter}
                    onClick={this._onNewsletterPress}
                    backgroundColorOver={backgroundColor}
                    borderColor={borderColor}
                    textStyle={"font-bold text-20 xl:text-23 " + textStyle}
                    style={"mb-8 w-full"}
                />
                <Button
                    text={Localization[locale].footer.privacy_policy}
                    backgroundColorOver={backgroundColor}
                    borderColor={borderColor}
                    to={getUrl("privacy")}
                    textStyle={"font-bold text-20 xl:text-23 " + textStyle}
                    style={"mb-8"}
                />
                <Button
                    text={Localization[locale].footer.cookies_policy}
                    backgroundColorOver={backgroundColor}
                    borderColor={borderColor}
                    to={getUrl("cookies")}
                    textStyle={"font-bold text-20 xl:text-23 " + textStyle}
                    style={"mb-8"}
                />
                <Button
                    text={Localization[locale].footer.terms_use}
                    backgroundColorOver={backgroundColor}
                    borderColor={borderColor}
                    to={getUrl("terms")}
                    textStyle={"font-bold text-20 xl:text-23 " + textStyle}
                />
            </div>
        );
    }

    render() {
        const { locale } = this.props;

        let color = "blue";
        let baseClassName = "bg-white";

        if (
            location.pathname.includes(getUrl("about")) ||
            location.pathname.includes(getUrl("spaces_booking"))
        ) {
            color = "orange";
        } else if (location.pathname.includes(getUrl("artists"))) {
            color = "pink";
        }

        const textStyle =
            "z-10 transition hover-hover:group-hover:text-white text-" + color;
        const backgroundColor = "bg-" + color;
        const borderColor = "border-" + color;

        if (
            location.pathname.includes(getUrl("account/profile")) ||
            location.pathname.includes(getUrl("account/profile/edit")) ||
            location.pathname.includes(getUrl("account/artistic")) ||
            location.pathname.includes(getUrl("account/claim")) ||
            location.pathname.includes(getUrl("account/spaces")) ||
            location.pathname.includes(getUrl("account/technical"))
        ) {
            baseClassName += " " + "hidden xl:block";
        } else {
            baseClassName += " " + "";
        }

        return (
            <div className={baseClassName}>
                <div className="px-16 xl:px-50 py-60 xl:py-80">
                    {this._renderTop(color)}
                    <div className="hidden xl:flex">
                        <div className="flex flex-col flex-1">
                            <div className="flex mb-80">
                                <Button
                                    text={appLocales[0].toUpperCase()}
                                    backgroundColor={
                                        locale === appLocales[0] &&
                                        "bg-" + color
                                    }
                                    backgroundColorOver={backgroundColor}
                                    onClick={() => {
                                        this._onLocalePress(appLocales[0]);
                                    }}
                                    borderColor={borderColor}
                                    textStyle={
                                        locale === appLocales[0]
                                            ? "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-white"
                                            : "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-" +
                                              color
                                    }
                                    style={"w-60 mr-4"}
                                />
                                <Button
                                    text={appLocales[1].toUpperCase()}
                                    backgroundColor={
                                        locale === appLocales[1] &&
                                        "bg-" + color
                                    }
                                    backgroundColorOver={backgroundColor}
                                    onClick={() => {
                                        this._onLocalePress(appLocales[1]);
                                    }}
                                    borderColor={borderColor}
                                    textStyle={
                                        locale === appLocales[1]
                                            ? "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-white"
                                            : "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-" +
                                              color
                                    }
                                    style={"w-60"}
                                />
                            </div>
                            {this._renderLegalButtons(
                                locale,
                                backgroundColor,
                                borderColor,
                                textStyle
                            )}
                        </div>
                        {this._renderContacts(color)}
                    </div>
                    <div className="flex xl:hidden mb-40">
                        {this._renderContacts(color)}
                    </div>
                    <div className="flex xl:hidden">
                        {this._renderLegalButtons(
                            locale,
                            backgroundColor,
                            borderColor,
                            textStyle
                        )}
                    </div>
                    <div className="flex justify-center xl:hidden my-40">
                        <Button
                            text={appLocales[0].toUpperCase()}
                            backgroundColor={
                                locale === appLocales[0] && "bg-" + color
                            }
                            backgroundColorOver={backgroundColor}
                            onClick={() => {
                                this._onLocalePress(appLocales[0]);
                            }}
                            borderColor={borderColor}
                            textStyle={
                                locale === appLocales[0]
                                    ? "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-white"
                                    : "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-" +
                                      color
                            }
                            style={"w-60 mr-4"}
                        />
                        <Button
                            text={appLocales[1].toUpperCase()}
                            backgroundColor={
                                locale === appLocales[1] && "bg-" + color
                            }
                            backgroundColorOver={backgroundColor}
                            onClick={() => {
                                this._onLocalePress(appLocales[1]);
                            }}
                            borderColor={borderColor}
                            textStyle={
                                locale === appLocales[1]
                                    ? "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-white"
                                    : "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-" +
                                      color
                            }
                            style={"w-60"}
                        />
                    </div>
                    {this._renderBottom(color)}
                </div>
            </div>
        );
    }
}

Footer.defaultProps = {};

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeNewsletter,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
